import type { HelpFile } from '../../types/help'
import { MintApiKeyDialogTestIds } from '../../../testids/MintApiKeyDialogTestIds'

export const mintApiKeyDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [MintApiKeyDialogTestIds.mintDialogTitle]: null,
    [MintApiKeyDialogTestIds.mintForm]: null,
    [MintApiKeyDialogTestIds.mintInputName]:
      'Anzeigename, der in der Tabelle der API-Schlüssel erscheint — typischerweise eine Workload- oder Pipeline-Kennung (1–100 Zeichen).',
    [MintApiKeyDialogTestIds.mintInputExpiry]:
      'Wann der Schlüssel ungültig wird. Standardwert ist heute + 365 Tage; Administratoren können die Lebensdauer pro Schlüssel verkürzen.',
    [MintApiKeyDialogTestIds.mintInputRateLimit]:
      'Optionales Anfragelimit pro Schlüssel (Anfragen pro Minute). Leer lassen, um den globalen Standardwert zu verwenden.',
    [MintApiKeyDialogTestIds.mintWarningBanner]:
      'Der Klartextschlüssel wird genau einmal angezeigt — auf diesem Bildschirm. Es gibt keinen Wiederherstellungspfad — kopieren Sie ihn vor dem Schließen.',
    [MintApiKeyDialogTestIds.mintRawKeyInput]:
      'Der erzeugte API-Schlüssel. Speichern Sie ihn jetzt in Ihrem Passwort-Manager, Tresor oder CI-Secret-Store; er kann später nicht mehr abgerufen werden.',
    [MintApiKeyDialogTestIds.btnCopyRawKey]:
      'Den Klartextschlüssel in die Zwischenablage kopieren. In Nicht-HTTPS-Kontexten (z. B. lokale Entwicklung) deaktiviert — kopieren Sie das Feld dann manuell.',
    [MintApiKeyDialogTestIds.mintCopyDisabledMessage]: null,
    [MintApiKeyDialogTestIds.btnMintSavedClose]:
      'Bestätigen Sie, dass der Schlüssel gespeichert ist, und schließen Sie den Dialog. Der Schlüssel wird aus dem React-State entfernt und kann nicht erneut angezeigt werden.',
    [MintApiKeyDialogTestIds.mintSubmitError]: null,
  },
}
